export const GoogleSignin = {
  configure: () => false,
  signIn: () => false,
};
